var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#EAFFF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 23.1998L12.5001 19.6998C12.1101 19.3098 11.4901 19.3098 11.1001 19.6998C10.7101 20.0898 10.7101 20.7098 11.1001 21.0998L15.2901 25.2898C15.6801 25.6798 16.3101 25.6798 16.7001 25.2898L27.3001 14.6998C27.6901 14.3098 27.6901 13.6898 27.3001 13.2998C26.9101 12.9098 26.2901 12.9098 25.9001 13.2998L16.0001 23.1998Z",
    fill: "#18AD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccess);
export default __webpack_public_path__ + "static/media/toast_success.0c39c8a2f2b56750586c51854ddd3052.svg";
export { ForwardRef as ReactComponent };